import { render } from "./TransactionCard.vue?vue&type=template&id=0a9404a4"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__